<template>
    <div>
        <vue-headful title="OSHA Subcontractors :: MeritEHS"/>

        <h4 class="py-3 mb-4">
            <ol class="breadcrumb font-weight-bold m-0">
                <li class="breadcrumb-item active"><i class="fa fa-id-badge"></i> OSHA Data</li>
            </ol>
        </h4>

        <div class="card">
            <div class="card-body">
                <osha-sub-list />
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        data: function() {
            return {

            }
        },

        methods: {

        },
    }
</script>
